module.exports = __webpack_public_path__ + "img/thumb-songspace2.779a7f58.png";